"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    overlayPlaySvgFill: {
        fill: function (data) { return data.color; },
    },
    overlayPlaySvgStroke: {
        stroke: function (data) { return data.color; },
    },
};
//# sourceMappingURL=overlay.theme.js.map